export default function Packaging() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Export-Grade Secure Packaging',
      description: 'International standard packaging that ensures product safety during long-distance transportation'
    },
    {
      icon: 'ri-stack-line',
      title: 'Bulk Packing Solutions',
      description: 'Efficient bulk packaging options designed for large-scale orders starting from 25 Ton MOQ'
    },
    {
      icon: 'ri-ship-2-line',
      title: 'Shipment-Ready Quality',
      description: 'All products are packed and prepared to meet global shipping and customs requirements'
    }
  ];

  return (
    <section id="packaging" className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Export-Quality <strong className="text-teal-600">Packaging</strong>
          </h2>
          <div className="w-24 h-1 bg-teal-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Professional packaging solutions that meet international standards
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all border border-gray-100"
            >
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-center leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-teal-600 to-teal-700 rounded-2xl p-8 md:p-12 text-center text-white shadow-xl">
          <h3 className="text-3xl font-bold mb-4">
            Quality Packaging for Global Markets
          </h3>
          <p className="text-lg text-teal-50 max-w-3xl mx-auto leading-relaxed">
            Our packaging meets international food safety standards and ensures your products arrive in perfect condition. 
            From moisture-proof materials to tamper-evident seals, we take every measure to protect your investment.
          </p>
        </div>
      </div>
    </section>
  );
}
